import {HTTP_INTERCEPTORS, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, throwError as observableThrowError} from 'rxjs';
import {catchError} from "rxjs/operators";
import {NotificationsService} from "../../service/notifications.service";

export const SEVERITY_WARN = 'warning';
export const SEVERITY_ERROR = 'error';

const IGNORED_CODES = [401, 417];
const ERRORS = [
  {code: 404, severity: SEVERITY_WARN, summary: 'Not found'},
  {code: 405, severity: SEVERITY_WARN, summary: ''},
  {code: 408, severity: SEVERITY_WARN, summary: 'Timeout'},
  {code: 412, severity: SEVERITY_WARN, summary: ''},
  {code: 422, severity: SEVERITY_WARN, summary: ''}
];

@Injectable()
export class ErrorHandlingInterceptor implements HttpInterceptor {

  constructor(private notificationsService: NotificationsService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req)
      .pipe(
        catchError(err => {
          let responseError: string = err.error || {};

          if (typeof responseError === 'string') {
            try {
              responseError = JSON.parse(responseError);
            } catch (e) {
            }
          }

          const message = err?.error?.message;
          const httpCode: number = err.status;
          let severity = SEVERITY_WARN;

          const newError = Object.assign({}, err, {error: responseError});

          if (IGNORED_CODES.indexOf(httpCode) !== -1) {
            return observableThrowError(newError);
          }

          let error = ERRORS.filter(err => err.code === httpCode)[0];
          if (error) {
            severity = error.severity;
          } else if (httpCode >= 500) {
            severity = SEVERITY_ERROR;
          } else if (httpCode >= 400) {
            severity = SEVERITY_WARN;
          }

          if (req.responseType === 'blob') {
            err.error.text().then((t: string) => {
              let errorObj = JSON.parse(t);
              this.notificationsService.messageNotify(severity, errorObj.message);
            });
            return observableThrowError(newError);
          }

          this.notificationsService.messageNotify(severity, message);

          return observableThrowError(newError);
        }),
      );
  }
}

export const ERROR_HANDLING_PROVIDER = {
  provide: HTTP_INTERCEPTORS,
  useClass: ErrorHandlingInterceptor,
  multi: true
};
